var _defs, _path, _rect, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e1e4ea;}.cls-2{fill:#73829a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tooltip") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10.9,
    y: 15.3,
    width: 2.2,
    height: 2.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.46,11.66s-.42.46-.74.78a4.86,4.86,0,0,0-.43.52l-.1.16a2.38,2.38,0,0,0-.21.41,1.9,1.9,0,0,0-.18.67H11A2.7,2.7,0,0,1,11.37,13a3.61,3.61,0,0,1,.22-.34,1.54,1.54,0,0,1,.11-.18c.12-.15.25-.31.37-.44l1-1a1.65,1.65,0,0,0-1.17-2.82,1.64,1.64,0,0,0-1.55,1.09.83.83,0,0,1-.78.56.83.83,0,0,1-.78-1.11A3.3,3.3,0,0,1,15.23,9.8,2.63,2.63,0,0,1,14.46,11.66Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.21968916fb9fbeac609ebb5edd7a31aa.svg";
export { ForwardRef as ReactComponent };